import React from "react";

import { StatusOnlineIcon } from "@heroicons/react/outline";
import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Text,
  Title,
  Badge,
} from "@tremor/react";

const Applicants = ({ data }) => {
  return (
    <Card className="mt-3">
      <Title>Ενάγοντες</Title>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Αυξ. Αριθμός</TableHeaderCell>
            <TableHeaderCell>Κατηγορία</TableHeaderCell>
            <TableHeaderCell>Επώνυμο</TableHeaderCell>
            <TableHeaderCell>Όνομα</TableHeaderCell>
            <TableHeaderCell>Πατρώνυμο</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => (
            <TableRow key={`d${i}`}>
              <TableCell>{item.afxon}</TableCell>
              <TableCell>
                <Text>{item.katigoria}</Text>
              </TableCell>
              <TableCell>{item.eponymo}</TableCell>
              <TableCell>{item.onoma}</TableCell>
              <TableCell>{item.patronymo}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default Applicants;
